import React from "react";

interface LoadingIndicatorProps {
  theme?: "primary" | "secondary" | "neutral";
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ theme = "neutral" }) => {
  // Map the theme to Tailwind color classes
  const themeColors: Record<string, string> = {
    primary: "bg-primary",
    secondary: "bg-secondary",
    neutral: "bg-gray-300",

  };

  const dotColor = themeColors[theme] || themeColors["neutral"]; // Default to primary if theme is invalid

  return (
    <div className="flex items-center space-x-1">
      <div
        className={`w-2 h-2 ${dotColor} rounded-full animate-bounce`}
        style={{ animationDelay: "0s" }}
      ></div>
      <div
        className={`w-2 h-2  ${dotColor} rounded-full animate-bounce`}
        style={{ animationDelay: "0.2s" }}
      ></div>
      <div
        className={`w-2 h-2  ${dotColor} rounded-full animate-bounce`}
        style={{ animationDelay: "0.4s" }}
      ></div>
    </div>
  );
};

export default LoadingIndicator;